/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the account module.
 */

export const STORE = 'STORE'
export const UPDATE = 'UPDATE'
export const CHECK = 'CHECK'
export const LOAD = 'LOAD'
export const UNLOAD = 'UNLOAD'
export const SET_COMPREHENSIVE_PRIVACY_NOTICE = 'SET_COMPREHENSIVE_PRIVACY_NOTICE'
export const SET_CONFIDENTIALITY_DATA_PROCESSING_LETTER = 'SET_CONFIDENTIALITY_DATA_PROCESSING_LETTER'
export const SET_POLICY_WHATSAPP_BUSINESS = 'SET_POLICY_WHATSAPP_BUSINESS'

export default {
  STORE,
  UPDATE,
  CHECK,
  LOAD,
  UNLOAD,
  SET_COMPREHENSIVE_PRIVACY_NOTICE,
  SET_CONFIDENTIALITY_DATA_PROCESSING_LETTER,
  SET_POLICY_WHATSAPP_BUSINESS
}
